/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Ma_Don_ExInputs */

const vi_station_voice_ph_ma_don_ex = /** @type {(inputs: Station_Voice_Ph_Ma_Don_ExInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DH123 đọc thành D H một hai ba`)
};

/**

* @param {Station_Voice_Ph_Ma_Don_ExInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_ma_don_ex = /** @type {((inputs?: Station_Voice_Ph_Ma_Don_ExInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Ma_Don_ExInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_ma_don_ex(inputs)
});